export default "* Fisk\n* Tangloppe\n* Fangeleg";